<div
  class="bg-white flex flex-col"
  [style.width]="width()"
  [style.height]="height()">
  @if (showHeader()) {
    <div
      class="flex items-center justify-between py-xl border-neutral-200 mx-2xl flex-shrink-0"
      [class.border-b]="hasTitleBottomBorder()">
      <p class="text-lg font-semibold text-neutral-900">
        {{ 'notification_page_title' | transloco }}
      </p>
      <div class="flex items-center gap-lg">
        <button
          [disabled]="notifications().length === 0 || !hasUnreadMessages()"
          class="font-medium bg-transparent border-none text-sm"
          [class.text-primary-500]="hasUnreadMessages()"
          [class.text-neutral-300]="!hasUnreadMessages()"
          [class.cursor-pointer]="hasUnreadMessages()"
          (click)="onMarkAllAsRead()">
          {{ 'mark_all_notifications_as_read' | transloco }}
        </button>
        <button
          class="bg-transparent border-none p-0 cursor-pointer flex items-center"
          (click)="onSettingsClick()">
          <lib-setting-icon
            [iconClass]="'size-6 text-neutral-500'"></lib-setting-icon>
        </button>
      </div>
    </div>
  }

  @if (showTabs() && notificationFilterTabs().length) {
    <div class="flex border-b border-neutral-200 items-center mx-2xl">
      @for (tab of notificationFilterTabs(); track $index) {
        <button
          type="button"
          class="flex items-center gap-sm p-lg border-b relative transition-all"
          (click)="onTabChange(tab)"
          [class.border-primary-500]="tab.active"
          [class.text-primary-700]="tab.active"
          [class.border-neutral-300]="!tab.active"
          [class.text-neutral-700]="!tab.active">
          <h5 class="text-sm font-medium m-0">
            {{ tab.label }}
          </h5>
          @if (tab.count !== undefined) {
            <span
              class="rounded-full text-xs font-medium px-sm bg-primary-100 text-primary-700"
              [class.bg-primary-100]="tab.active"
              [class.text-primary-700]="tab.active"
              [class.bg-neutral-100]="!tab.active"
              [class.text-neutral-700]="!tab.active">
              {{ tab.count }}
            </span>
          }
        </button>
      }
    </div>
  }
  @if (sortedNotifications().length === 0) {
    <div
      class="flex flex-col items-center justify-center text-neutral-900 w-full flex-1 gap-md">
      <lib-no-notification-icon
        [iconClass]="noStateIconSize()"></lib-no-notification-icon>
      <h6 class="font-semibold m-0" [class]="noStateTitleSize()">
        {{ 'notification_page_no_notification_title' | transloco }}
      </h6>
      <p class="text-neutral-500 m-0" [class]="noStateDescriptionSize()">
        {{ 'notification_page_no_notification_description' | transloco }}
      </p>
    </div>
  } @else {
    <div
      class="w-full flex-1"
      [class.overflow-y-auto]="useScrollPagination()"
      libScrollBottom
      (scrolledBottom)="onScrolledBottom()">
      <div class="py-md">
        @for (notification of sortedNotifications(); track notification.id) {
          @if (
            $index === 0 ||
            isToday(notification.created_at) !==
              isToday(sortedNotifications()[$index - 1].created_at)
          ) {
            <p class="text-xs2 font-medium text-neutral-500 m-0 px-2xl py-sm">
              {{
                isToday(notification.created_at)
                  ? ('notification_page_today' | transloco)
                  : ('notification_page_earlier' | transloco)
              }}
            </p>
          }

          <div
            class="flex gap-md py-lg cursor-pointer transition-colors border-b border-neutral-200 last:border-b-0 mx-2xl"
            (click)="onNotificationClick(notification)">
            <div
              [class]="
                'flex-shrink-0 w-4xl h-4xl rounded-lg flex items-center justify-center relative p-xl gap-lg ' +
                getIconBgClass(notification)
              ">
              <ng-container
                [ngTemplateOutlet]="notificationIcon"
                [ngTemplateOutletContext]="{
                  $implicit: notification,
                  isRead: !!notification.read_at,
                }">
              </ng-container>

              @if (!notification.read_at) {
                <span
                  class="absolute -top-[.0625rem] end-0 w-sm h-sm bg-destructive-500 rounded-full border-sm border-white"></span>
              }
            </div>

            <div class="flex-1 min-w-0">
              <div class="relative">
                <div class="min-w-0 pe-[2rem]">
                  <h4
                    class="m-0 text-sm font-semibold text-neutral-900 mb-x-sm">
                    {{
                      notification.title || notification.notification_type.label
                    }}
                  </h4>
                  <p
                    class="m-0 text-neutral-600 text-xs2 leading-relaxed line-clamp-2">
                    {{ notification.message || '' }}
                  </p>
                </div>

                <span
                  class="absolute top-0 end-0 text-xs2 text-neutral-500 whitespace-nowrap">
                  {{
                    isToday(notification.created_at)
                      ? (notification.created_at | date: 'hh:mm a')
                      : (notification.created_at | date: 'dd-MMM-yyyy hh:mm a')
                  }}
                </span>
              </div>

              <button
                class="mt-md bg-transparent border-none text-primary-500 font-semibold cursor-pointer p-0 inline-flex items-center gap-x-sm text-sm"
                (click)="onViewDetailsClick($event, notification)">
                {{ 'view_details_button' | transloco }}
                <lib-chevron-right-icon
                  iconClass="size-4"></lib-chevron-right-icon>
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>

<ng-template #notificationIcon let-notification let-isRead="isRead">
  @let textColor = isRead ? 'text-neutral-500' : 'text-primary-500';
  @let fillColor = isRead ? 'fill-neutral-500' : 'fill-primary-500';
  @switch (notification.notification_type.value) {
    @case (NotificationTypeValue.SLA_TIME_NOTIFICATION) {
      <lib-danger-icon
        [iconClass]="
          'size-6 ' + (isRead ? 'text-neutral-500' : 'text-destructive-500')
        " />
    }

    @case (NotificationTypeValue.ESCALATION) {
      <lib-users-solid-icon
        iconClass="size-6"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }

    @case (NotificationTypeValue.NEW_TASK_ASSIGNED) {
      <lib-direct-box-reactive-icon
        iconClass="size-6"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }

    @case (NotificationTypeValue.COMPILATION) {
      <lib-workflow-icon
        iconClass="size-6"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.COLLABORATION) {
      <lib-user-octagon-icon
        iconClass="size-6"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.SLA_REACHED) {
      <lib-tick-square-icon
        [iconClass]="'size-6 text-white'"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.COMMENT_MENTION) {
      <lib-mention-icon
        iconClass="size-6"
        [stroke]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.ON_HOLD) {
      <lib-pending-icon
        iconClass="size-7 text-white"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.RESUMED) {
      <lib-resume-icon
        iconClass="size-7"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.REQUEST_UPDATED) {
      <lib-notification-status-icon
        [iconClass]="'size-6'"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.COMMENT_REACTION) {
      <lib-reaction-icon
        iconClass="size-7"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.CONTRIBUTOR_ADDED) {
      <lib-user-two-icon
        iconClass="size-7"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.CONTRIBUTOR_SUBMITTED_DATA) {
      <lib-tick-square-icon
        [iconClass]="'size-6 text-white'"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }

    @case (NotificationTypeValue.DELEGATION_ACTIVATED) {
      <lib-user-notification-icon
        iconClass="size-7 text-primary-500"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.UPCOMING_DELEGATION) {
      <lib-arrow-up-circle-icon
        iconClass="size-7 text-primary-500"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.BORROWING_CREATED) {
      <lib-money-add-icon
        iconClass="size-7 text-primary-500"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.BORROWING_UPDATED) {
      <lib-moneys-icon
        iconClass="size-7 text-primary-500"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.TIME_DEPOSIT_CREATED) {
      <lib-card-add-icon
        iconClass="size-7 text-primary-500"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.TIME_DEPOSIT_UPDATED) {
      <lib-card-edit-icon
        iconClass="size-7 text-primary-500"
        [fill]="
          isRead ? 'var(--color-neutral-500)' : 'var(--color-primary-500)'
        " />
    }
    @case (NotificationTypeValue.BACKGROUND_TASK_RECEIVED) {
      <lib-arrow-up-circle-icon [iconClass]="'size-7 ' + textColor" />
    }
    @case (NotificationTypeValue.BACKGROUND_TASK_COMPLETED) {
      <lib-tick-square-icon [iconClass]="'size-6 text-white ' + fillColor" />
    }
    @case (NotificationTypeValue.BACKGROUND_TASK_FAILED) {
      <lib-danger-icon
        [iconClass]="
          'size-6 ' + (isRead ? 'text-neutral-500' : 'text-destructive-500')
        " />
    }
  }
</ng-template>
